<template>
  <div>
    <div class="bg-wrapper hidden pc:block">
      <div class="bg mx-auto flex max-w-[1920px] items-center justify-center py-[76px]">
        <p class="text-[40px] font-bold text-neutral-950">성인 과정</p>
      </div>
    </div>

    <section class="pb-[70px] pt-[55px] pc:pb-[140px] pc:pt-[70px]">
      <div>
        <div class="show-list flex items-center justify-between bg-[#323740] p-2 pc:hidden">
          <div class="w-3"></div>
          <p class="text-sm font-bold text-white">과정 리스트 보기</p>
          <div class="w-3">
            <img src="@/assets/images/courseIntroduce/adult/arrow.png" alt="icon" class="show-arrow transition-all" />
          </div>
        </div>
        <ul class="lang-list flex pc:mx-auto pc:max-w-[1200px] pc:flex-col">
          <li class="w-[40%] bg-[#ececec] pc:w-full pc:bg-white">
            <ul class="gap-10 border-solid border-[#f1f1f1] pc:flex pc:border-b">
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#fb6930]"
                @click="goPage('/courseIntroduce/adultEng/PageAll')"
              >
                영어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultChi/pageAll')">
                중국어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultJap/pageAll')">
                일본어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultEtc')">
                제2외국어
              </li>
            </ul>
          </li>
          <li class="w-[60%] pc:w-full">
            <ul class="sub-list gap-9 divide-y divide-solid divide-[#e9e9e9] pc:flex pc:divide-y-0">
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/PageAll')"
              >
                전체 커리큘럼 맵
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/page1')"
              >
                일반회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/page2')"
              >
                비즈니스회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#fb6930]"
                @click="goPage('/courseIntroduce/adultEng/page3')"
              >
                토론회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/page4')"
              >
                시험·인터뷰대비
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/page5')"
              >
                로이터뉴스
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultEng/page6')"
              >
                Global Topic
              </li>
            </ul>
          </li>
        </ul>
        <div class="pc-con-wrapper5">
          <div class="bg3 mb-7 flex flex-col items-center px-5 py-10 pc:mb-11 pc:py-[90px]">
            <p class="mb-2 text-center text-[35px] font-bold text-white">토론회화</p>
            <div class="mb-6 h-[2px] w-[72px] bg-[#fb6930]"></div>
            <p class="text-center text-white pc:text-2xl">
              토론 수업을 통한 논리력 강화 및 실전 스피치 훈련이 진행 됩니다.<br />고급 표현 및 정치, 경제, 사회 부문 별 주요
              이슈를 함께 학습합니다.
            </p>
          </div>
          <div class="pc-con-wrapper4 px-5">
            <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/eng/bg3-book01.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">중급~고급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://mediabook.carrotenglish.kr/?idxMediabook=7&idxLesson=161')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">Active Discussion 1</p>
                <p class="mb-1 text-sm text-[#535353]">
                  일반적 토픽과 최신 이슈 학습을 통한 토론 과정으로, 다양한 토픽에 대한 영어표현 학습 및 논리적 스피치 연습하는
                  과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#중고급</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#주제별</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#토론회의</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/eng/bg3-book02.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">중급~고급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://mediabook.carrotenglish.kr/?idxMediabook=7&idxLesson=417')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">Active Discussion 2</p>
                <p class="mb-1 text-sm text-[#535353]">
                  일반적 토픽과 최신 이슈 학습을 통한 토론 과정으로, 다양한 토픽에 대한 영어표현 학습 및 논리적 스피치 연습하는
                  과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#중고급</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#주제별</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#토론회의</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/eng/bg3-book03.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">중급~고급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://app.carrotenglish.com/carrotdata/pdf/program_d_2.pdf')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">Dynamic Discussion</p>
                <p class="mb-1 text-sm text-[#535353]">
                  실제 사례 중심의 부문별 이슈를 학습한 고급표현을 통해 토론하는 심화형 학습하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#중급</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#사례중심</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#고급표현</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const goPage = (url) => {
      location.href = url;
    };

    const goSite = (url) => {
      window.open(url, "_blank");
    };

    onMounted(() => {
      const showListButton = document.querySelector(".show-list");
      const arrowIcon = showListButton.querySelector(".show-arrow");
      const listToToggle = document.querySelector(".lang-list");
      const countryListItems = document.querySelectorAll(".sub-list li");

      showListButton.addEventListener("click", function () {
        if (listToToggle.style.display === "none") {
          listToToggle.style.display = "flex";
        } else {
          listToToggle.style.display = "none";
        }

        arrowIcon.classList.toggle("rotate-180");
      });

      countryListItems.forEach(function (item) {
        item.addEventListener("click", function () {
          listToToggle.style.display = "none";
          arrowIcon.classList.remove("rotate-180");
        });
      });
    });

    return {
      goPage,
      goSite,
    };
  },
};
</script>
<style lang="scss" scoped>
.bg3 {
  background: url(@/assets/images/courseIntroduce/adult/eng/bg3.png) no-repeat center / 1920px;
}
</style>
